import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { countAge } from "../validation";

import useStyles from "./styles";
import moment from "moment";

import validation from "../validation";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";

function SubFormRadio({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  wilayah,
  keluarga,
  handleBackSub,
  navigationMode,
  isSingle,
  setIsSingle,
  subformIndex,
  direction,
  backRadio,
  isSubmitting,
  pk,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [berlaku, setBerlaku] = useState(false);

  const [jawaban, setJawaban] = useState(value.jawaban || "");
  const [jwbLain, setJwbLain] = useState(value.jawaban_lainnya || "");
  const [kondisi, setKondisi] = useState(value.kondisi || 0);
  const [hasAnak, setHasAnak] = useState(false);

  const objKeluarga = Object.values(keluarga)[0];
  const [singleParent, setSingleParent] = useState(
    wilayah.year_doc === "2025" &&
      wilayah.jumlah_keluarga !== "1" &&
      wilayah.sts_keluarga === "1" &&
      objKeluarga.jenis_kelamin === "2" &&
      objKeluarga.sts_hubungan === "1"
  );
  useEffect(() => {
    const anggotaKeluarga = Object.values(keluarga);
    // console.log("Anggota keluarga:", anggotaKeluarga);

    const cekChild = () => {
      const yearDiff = (tanggal) => {
        const dateA = moment();
        const dateB = moment(tanggal);
        const year = dateA.diff(dateB, "years", true);
        return parseInt(year);
      };
      let res = false;
      anggotaKeluarga.forEach((el) => {
        const dateParts = el.tgl_lahir.split("-");
        const tglLahir = new Date(
          +dateParts[2],
          +dateParts[1] - 1,
          +dateParts[0]
        );
        const age = yearDiff(tglLahir);
        // console.log("umur anak>>>", age);
        // console.log("status hubungan>>>", el.sts_hubungan);
        // console.log("status kawin>>>", el.sts_kawin);

        if (
          (+el.sts_hubungan === 3 || +el.sts_hubungan === 4) &&
          +el.sts_kawin === 1 &&
          age <= 17
        ) {
          res = true;
        }
      });
      return res;
    };

    // console.log("Pengecekan anak di radio.js:", anak);
    setHasAnak(cekChild());
  }, [keluarga]);
  useEffect(() => {
    setError({});
  }, []);

  // useEffect(() => {
  //   // console.log("value.jawaban:", value.jawaban, "form.no:", form.no);

  //   // For question 8, add extra debugging
  //   // if (form.no === "08") {
  //   //   console.log("Question 8 detected - Current value:", value.jawaban);
  //   //   console.log("Local state 'jawaban':", jawaban);
  //   // }
  // }, [value, form.no, jawaban]);

  // useEffect(() => {
  //   if (form.no === "08" && value.jawaban === "1" && value.jawaban === "2") {
  //     const event = {
  //       target: {
  //         name: "jawaban",
  //         value: "2", // Set it to "No" (assuming "2" is the value for "No")
  //       },
  //     };
  //     setTimeout(() => {
  //       setValue(event);
  //     }, 0);
  //   }
  // }, [form.no, value.jawaban, jawaban]);

  // useEffect(() => {
  //   if (form.no === "08") {
  //     console.log(
  //       "Form 08 render - value.jawaban:",
  //       value.jawaban,
  //       "local state jawaban:",
  //       jawaban
  //     );
  //     console.log("Form 08 props:", { form, value, setValue });

  //     // Check where setValue is coming from and what it's doing
  //     if (setValue && typeof setValue === "function") {
  //       const originalSetValue = setValue;
  //       setValue = (e) => {
  //         console.log("setValue called with:", e);
  //         return originalSetValue(e);
  //       };
  //     }
  //   }
  // }, [form.no, value, jawaban]);

  useEffect(() => {
    let valIndex = 0;
    if (
      wilayah.status_draft == 1 &&
      wilayah.pos_draft == 3 &&
      wilayah.subformIndex !== undefined
    ) {
      valIndex = wilayah.subformIndex;
      if (value.jawaban !== undefined) {
        // handleSubmit(null)
        //
      }
    }

    if (form.no === "12" && !value.jawaban) {
      const lastOptionIndex = form.options.length;
      setValue({
        target: { name: "jawaban", value: `${lastOptionIndex}` },
      });
    }

    if (form.dependencies.length <= 0) {
      setBerlaku(true);
    } else {
      const valuesKel = Object.values(keluarga);
      const cekberlaku = form.dependencies.some((dep) => {
        return validation[dep](valuesKel);
      });

      let normalizeValue;
      if (!cekberlaku && +form.no !== 11) {
        setValue({ target: { name: "jawaban", value: "3" } });

        if (direction.navigate === "right") {
          if (value.jawaban === undefined || value.jawaban === "3") {
            normalizeValue = {
              Pertanyaan: pertanyaan,
              Jawab_Pilih: "3",
              Jawaban_H1: value.kondisi || 0,
              Jawaban_H2: 0,
              No_Pertanyaan: parseInt(form.no),
              Lainnya: value.jawaban_lainnya || "",
            };

            if (value._rev) {
              normalizeValue._rev = value._rev;
            }

            saveValue(normalizeValue);
          }
        } else if (direction.navigate === "left") {
          if (value.jawaban === "3") {
            backRadio(cekberlaku);
          }
        }
      }
      setBerlaku(cekberlaku);
    }

    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, form]);

  const { pertanyaan } = form;

  const handleChange = (e) => {
    if (e?.target.type === "number") {
      if (parseInt(e?.target.value) < 0) return false;

      // if (e?.target.name === "kondisi" && ![0, 1].includes(parseInt(e?.target.value))) {
      //     return false;
      // }
    }

    if (form.no === "08" && e?.target?.name === "jawaban") {
      // console.log("Question 8 selection - User selected:", e.target.value);

      // Update the local state immediately
      setJawaban(e.target.value);

      // Set a direct normalizeValue for question 8
      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: e.target.value,
        Jawaban_H1: kondisi || 0,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: jwbLain || "",
      };

      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      // Force update the parent state
      setValue({
        target: {
          name: "jawaban",
          value: e.target.value,
        },
      });

      // Skip the regular saveChangeValue cycle and directly update
      setTimeout(() => {
        // Skip the regular saveChangeValue cycle and directly update
        saveChangeValue(normalizeValue);

        // Don't call saveValue here - it seems to trigger navigation
        // Instead, let the normal form submission handle it
      }, 50);

      // Also directly call saveValue to persist immediately
      // saveValue(normalizeValue);

      return; // Skip the rest of handleChange
    }

    setValue(e);

    setError({
      ...error,
      [e?.target.name]: "",
    });

    switch (e?.target.name) {
      case "jawaban":
        setJawaban(e?.target.value);
        break;
      case "jawaban_lainnya":
        setJwbLain(e?.target.value);
        break;
      case "kondisi":
        setKondisi(e?.target.value);
        break;
      default:
        break;
    }
    // setSomethingChange(true)
  };

  // useEffect(() => {
  //   console.log("value.jawaban:", value.jawaban);
  // }, [value]);

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: jawaban,
      Jawaban_H1: kondisi || 0,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: jwbLain || "",
    };

    if (value._rev) {
      normalizeValue._rev = value._rev;
    }

    //

    saveChangeValue(normalizeValue);
  }, [jawaban, jwbLain, kondisi]);

  const validate = () => {
    let newError = {};

    if (!value.jawaban) {
      newError.jawaban = "Wajib diisi";
    }
    if (form.no === "12") {
      const lastOptionValue = `${form.options.length}`;
      // console.log("Last option value:", lastOptionValue);
      // console.log(true);
      if (!hasAnak) {
        if (value.jawaban !== lastOptionValue) {
          newError.jawaban = "Wajib diisi dengan 'Tidak Berlaku'";
        }
      } else {
        if (value.jawaban === lastOptionValue) {
          newError.jawaban = "Wajib diisi selain 'Tidak Berlaku'";
        }
      }
    }

    // if (berlaku) {
    //   if (subformIndex < 17) {
    //     if (value.jawaban === 3) {
    //       newError.jawaban = "Jawaban selain tidak berlaku";
    //     }
    //   }
    // }

    // if (!berlaku) {
    //   if (+form.no === 11) {
    //     // if (+value.jawaban !== 3) {
    //     //   newError.jawaban = "Jawaban harus tidak berlaku";
    //     // }
    //   }
    // }

    if (form.lain) {
      if (
        parseInt(value.jawaban) === form.options.length &&
        !value.jawaban_lainnya
      ) {
        newError.jawaban_lainnya = "Wajib diisi";
      }
    }

    if (form.kondisi) {
      if (typeof value.kondisi === "undefined") {
        newError.kondisi = "Kondisi wajib diisi";
      } else if (!["0", "1", 0, 1].includes(value.kondisi)) {
        newError.kondisi = "Kondisi harus diisi angka 0 atau 1";
      }
    }
    return newError;
  };

  const handleSubmit = (e) => {
    if (e !== null) {
      e.preventDefault();
    }

    const findErrors = validate();

    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      // const normalizeValue = {
      //     pertanyaan,
      //     jawaban_1: value.jawaban,
      //     jawaban_2: value.jawaban_lainnya

      // }

      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: value.jawaban,
        Jawaban_H1: value.kondisi || 0,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: value.jawaban_lainnya || "",
      };
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      // console.log("Submitting value:", normalizeValue);

      saveValue(normalizeValue);
    }
  };
  //

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                  <span className={classes.badge}>{form.no}</span>
                  <span dangerouslySetInnerHTML={{ __html: pertanyaan }}></span>
                </Typography>
              </div>
              <div style={{ position: "absolute", right: "0" }}>
                <InfoButton
                  title={`Pertanyaan ${form.no}`}
                  content={form.definisi_operasional}
                />
              </div>
            </Grid>
          </Grid>
          <div className={classes.cardBody} style={{ paddingTop: "40px" }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  error={error.jawaban ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawaban || ""}
                    // value={
                    //   form.no === "08" &&
                    //   window._q8UserChoice &&
                    //   window._q8UserChoice[form.no]
                    //     ? window._q8UserChoice[form.no]
                    //     : value.jawaban || ""
                    // }
                    onChange={handleChange}
                    aria-label="jawaban"
                    name="jawaban"
                  >
                    {form.options.map((option, index) => {
                      let disabled = false;
                      if (form.no === "12") {
                        if (hasAnak) {
                          disabled = false;
                          if (index === form.options.length - 1) {
                            disabled = true;
                          }
                        } else {
                          if (index !== form.options.length - 1) {
                            disabled = true;
                          }
                        }
                      }

                      // if (option === "Tidak Berlaku" && berlaku) {
                      //   disabled = true;
                      // } else if (option !== "Tidak Berlaku" && !berlaku) {
                      //   disabled = true;
                      // }

                      return (
                        <FormControlLabel
                          disabled={disabled}
                          key={index}
                          control={<Radio />}
                          value={`${index + 1}`}
                          label={`${index + 1}. ${option}`}
                        />
                      );
                    })}

                    {/* {(form.lain && parseInt(value.jawaban) === form.options.length) &&

                                    <TextField
                                        fullWidth

                                        placeholder="Tuliskan"
                                        variant="outlined"
                                        id="jawaban_lainnya"
                                        name="jawaban_lainnya"
                                        value={value.jawaban_lainnya || ''}
                                        onChange={handleChange}
                                        error={error.jawaban_lainnya ? true : false}
                                        helperText={error.jawa
                                ban_lainnya}
                                        inputProps={{
                                            className: classes.inputMini
                                        }}

                                    />
                                } */}
                  </RadioGroup>
                  <FormHelperText>{error.jawaban}</FormHelperText>
                </FormControl>
              </Grid>

              {/* {(value.jawaban && form.kondisi) &&
                        <>
                            <Grid item xs={12}>
                                <Typography>Tuliskan pada kotak, angka 0 Jika Kondisi Tidak Baik atau angka 1 Jika Kondisi Baik</Typography>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    id="kondisi"
                                    name="kondisi"
                                    value={value.kondisi || ''}
                                    onChange={handleChange}

                                    type="number"
                                    inputProps={{
                                        className: classes.inputMini,
                                        min: 0,
                                        max: 1
                                    }}
                                    error={error.kondisi ? true : false}
                                    helperText={error.kondisi}

                                />
                            </Grid>
                        </>
                    } */}
            </Grid>
          </div>
        </div>
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex === 29 ? "Simpan" : "Selanjutnya"}{" "}
          {/* {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "} */}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormRadio;
